import React from "react";

const SamplesIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-5 h-5"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 18v-1.5m0 0a3.75 3.75 0 0 0 2.36-6.66A3.75 3.75 0 1 0 9.64 9.84 3.75 3.75 0 0 0 12 16.5Zm-2.25 3.75h4.5m-4.5 1.5h4.5"
    />
  </svg>
);

export default SamplesIcon;
